export const DifferenceHighlighter = ({ string1, string2 }: any) => {
  // Ensure both strings are defined
  if (!string1 || !string2) {
    return null;
  }
  // Find the index where the strings start to differ
  let diffIndex = 0;
  while (diffIndex < string1.length && diffIndex < string2.length && string1[diffIndex] === string2[diffIndex]) {
    diffIndex++;
  }
  // Create a new array to store JSX elements with differences
  const highlightedChars = [];
  // Iterate through each character in string1
  for (let i = 0; i < string1.length; i++) {
    // Determine if the character differs from the corresponding character in string2
    const isDifferent = i >= diffIndex || string1[i] !== string2[i];
    // Apply bold style if the character differs or if it comes after the differing portion
    const style = isDifferent ? { fontWeight: 'bold' } : {};
    // Return the character wrapped in a <span> element with the appropriate style
    highlightedChars.push(
      <span key={i} style={style}>
        {string1[i]}
      </span>,
    );
  }
  return <p>{highlightedChars}</p>;
};
